/**
 * Griffin recommended setTitleCase method
 * https://github.paypal.com/pages/Globalization-R/griffin-paypal/docs/faq.html#how-can-i-generate-a-language-dropdown-for-a-country
 */
export function setTitleCase(str) {
	return str.replace(/(\S*)/g, function(txt) {
		return txt.charAt(0).toUpperCase() + txt.substr(1);
	});
}



// WEBPACK FOOTER //
// ./buttons/utils/commonUtils.js